/**
 * ============================================
 * Upgrade Prompt Component
 * ============================================
 * 
 * Shows upgrade message when feature is locked
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlan } from '../context/PlanContext';

const UpgradePrompt = ({ feature, message, inline = false }) => {
  const navigate = useNavigate();
  const { planInfo } = usePlan();

  const handleUpgrade = () => {
    navigate('/purchase-plan');
  };

  // Styling: AdminTheme.css .mtk-upgrade (saffron, like the plan CTAs on /purchase-plan)
  if (inline) {
    // Inline version for buttons/small areas
    return (
      <div className="mtk-upgrade mtk-upgrade--inline">
        <span className="ico" aria-hidden="true"><i className="fa-solid fa-lock"></i></span>
        <span className="msg">{message}</span>
        <button type="button" className="btn" onClick={handleUpgrade}>
          Upgrade
        </button>
      </div>
    );
  }

  // Full card version
  return (
    <div className="mtk-upgrade mtk-upgrade--card">
      <span className="ico" aria-hidden="true"><i className="fa-solid fa-crown"></i></span>
      <h3>Upgrade Required</h3>
      <p className="msg">{message}</p>
      {planInfo && (
        <p className="cur">
          Current Plan: <strong>{planInfo.plan_name}</strong>
        </p>
      )}
      <button type="button" className="btn" onClick={handleUpgrade}>
        <i className="fa-solid fa-rocket mr-2"></i>
        View Plans & Upgrade
      </button>
    </div>
  );
};

export default UpgradePrompt;
